import axios from "axios";
import { uniq } from 'lodash';

const API_URL = "https://deals.mu/scripts/reportsapi/issuesreports.php";

class IssuesService {

    getIssues(startDate, endDate, status, user_email) {
       return this.getResults(0, startDate, endDate, status, user_email)
            .then(response => {

                // console.log({response});

                var result = {
                    data: []
                };
                let promises = [];
                var size = parseFloat(response.data);

                var loopSize = Math.ceil(parseFloat(size / 50));

                for (var i = 1; i <= loopSize; i++) {

                    promises.push(
                        this.getResults(i, startDate, endDate, status, user_email)
                            .then(response1 => {

                                result.data = result.data.concat(response1.data);
                            })
                            .catch(error1 => {
                                console.log({ error1 });
                            })
                    );
                }

                return Promise.all(promises).then(() => {
                    // console.log({result});
                    return result;
                });

            }).catch(error => {

                return false;
            });
    }

    getResults(page, startDate, endDate, status, user_email) {
        var params = {
            action: 'get_all',
            page: page,
            startDate: startDate,
            endDate: endDate,
            status: status,
            user_email: user_email
        };
        return axios
            .post(API_URL, { params })
            .then((response) => {
                // console.log(response);
                return response;
            }).catch(error => {
                // localStorage.removeItem("user");
                return false;
            });
    }

    getSummary(id) {
        var params = {
            action: 'get_summary',
            id: id,
        };
        return axios
            .post(API_URL, { params })
            .then((response) => {
                // console.log(response);
                return response;
            }).catch(error => {
                // localStorage.removeItem("user");
                return false;
            });
    }

}

export default new IssuesService();